import Vue from 'vue'

import type { Media, MediaType } from '@/types'
import { getCurrentInstance, mountVueToBody } from '@/util'

export default function useMedia() {
  const instance = getCurrentInstance()

  async function pick(
    type?: MediaType,
    multiple?: boolean
  ): Promise<Media | null> {
    const { default: options } = await import(
      '@/components/MediaPickerDialog/MediaPickerDialog.vue'
    )

    return new Promise((resolve) => {
      const c = new Vue({
        extends: options,
        propsData: { type, multiple },
        parent: instance.proxy.$root,
      })
      const destroy = mountVueToBody(c)
      c.$once('success', (media: Media) => {
        resolve(media)
        destroy()
      })
      c.$once('fail', () => {
        resolve(null)
        destroy()
      })
    })
  }

  return {
    pick,
  }
}
